import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CafeMenuTimesService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public getCafeMenuTimes(
    cruCode: string | undefined,
    asofdate: string | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const CafeMenuTimesInfo: JSON = <JSON>(<unknown>{
      cruCode: cruCode,
      asofdate: asofdate,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetCafeMenuTimes',
      JSON.stringify(CafeMenuTimesInfo),
      { headers: headers }
    );
  }
}
